const LIST_BUSINESS_UNIT = "LIST_BUSINESS_UNIT";
const BUSINESS_UNIT_DETAIL = "BUSINESS_UNIT_DETAIL";

const businessUnitAction = {
  LIST_BUSINESS_UNIT,
  BUSINESS_UNIT_DETAIL,
};

export default businessUnitAction;
